import { render, staticRenderFns } from "./HomeColumnGoods.vue?vue&type=template&id=6c11e350&scoped=true&"
import script from "./HomeColumnGoods.vue?vue&type=script&lang=js&"
export * from "./HomeColumnGoods.vue?vue&type=script&lang=js&"
import style0 from "./HomeColumnGoods.vue?vue&type=style&index=0&id=6c11e350&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c11e350",
  null
  
)

export default component.exports